import styled from 'styled-components'

import { device } from '~/styles/device'

export const ContainerSelects = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  .selectMetrics-item {
    min-width: 12rem;
  }

  @media ${device.mobileL_max} {
    flex-direction: column;
  }

  .compare_container {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;

    margin-left: auto;
    text-align: right;

    label {
      justify-content: flex-end;
      text-align: right;
      max-width: 160px;
      margin-bottom: 0;
    }

    .inputContainer {
      min-height: 2.5rem;
    }
  }
`
